<template>
    <card style="max-height:450px; min-height: 450px;">
        <template slot="header">
            <h4 class="card-title pb-5p">{{ i18nValues["production"] }}</h4>
        </template>
        <bar-chart
            :height="270"
            :labels="estimationRankBar.labels"
            :datasets="estimationRankBar.datasets"
        ></bar-chart>
        <div class="legendPromotion" style="padding-bottom: 15px">
            <i class="fa fa-circle text-warningDash"></i>
            {{ i18nValues["initialEstimate"] }}
            <i class="fa fa-circle text-infoDash"></i>
            {{ i18nValues["finalEstimate"] }}
        </div>
    </card>
</template>
<script>
    import { StatsCard, ChartCard } from "@/components/dashboard/index";
    import BarChart from "@/components/dashboard/BarChart";
    export default {
        name: "EstimationSection",
        props: {
            estimationRankBar: Object,
        },
        components: {
            BarChart,
        },
        methods: {
        },
        data() {
            return {
            }
        }
    }
</script>
<style scoped>
    .align-end {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-end;
        align-items: center;
        align-content: center;
    }
    .pb-5p {
        padding-bottom: 5px;
    }
    .legendPromotion {
        margin-top: 8px;
    }
</style>